import React, { Component } from 'react';
import muiThemeable from 'material-ui/styles/muiThemeable';

import ShonaThankYou from './customThankYou/shonaThankYou';
import JessicaThankYou from './customThankYou/jessicaThankYou';
import DefaultThankYou from './customThankYou/defaultThankYou';
import GraceThankYou from './customThankYou/graceThankYou';
import MikedThankYou from './customThankYou/mikedThankYou';
import PatriciaThankYou from './customThankYou/patriciaThankYou';
import KrissyThankYou from './customThankYou/krissyThankYou';
import PineappleThankYou from './customThankYou/pineappleThankYou';


class ThankYou extends Component {
    render() {
        switch (window.location.host) {
            case 'checkout.gracefitguide.com':
                return <GraceThankYou styles={this.props.muiTheme.product} />
            case 'checkout.shonavertue.com':
                return <ShonaThankYou styles={this.props.muiTheme.product} />
            case 'checkout.jessicaolie.com':
                return <JessicaThankYou styles={this.props.muiTheme.product}/>
            case 'checkout.diamondsfitness.com':
                return <MikedThankYou styles={this.props.muiTheme.product}/>
            case 'checkout.thebreakplatform.com':
                return <PatriciaThankYou styles={this.props.muiTheme.product}/>
            case 'checkout.toneandsculpt.app':
                return <KrissyThankYou styles={this.props.muiTheme.product}/>
            case 'checkout.pineapplebrat.com':
                return <PineappleThankYou styles={this.props.muiTheme.product}/>
            default:
                return <DefaultThankYou />
        }
    }
}

export default muiThemeable()(ThankYou);
